import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _CargoManifest, _single, _Technicians } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_BOOLEAN, MASK_MONEY, MASK_TEXT_NOWRAP } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import usePaginator from "../../../theme/Component/usePaginator";
import { useRequiredFields } from "../../../theme/Component/hooks/useRequiredFields";
import { TransportDestinationEditor } from "../TransportDestination/TransportDestinationEditor";
import { EditorOfficeNew } from "../../../Talentohumano/GestionTH/EmployeeContract/Office/EditorOfficeNew";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { SelectCargoManifest } from "./SelectCargoManifest";
import { CargoManifestTransportGuides } from "./CargoManifestTransportGuides/CargoManifestTransportGuides";
import { BasicMultiSelectTable } from "../../../theme/Component/BasicMultiSelecTable";
import { _TransportGuide, _TransportGuideItem } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { EditorTransportGuideForCargoManifest } from "../TransportGuide/EditorTransportGuideForCargoManifest";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { EditorCurrentFlights } from "./Editors/EditorCurrentFlights";
import { EditorAircraft } from "../Aircraft/EditorAircraft";
import { SelectCargoManifestType } from "./SelectCargoManifestType";
import { CargoManifestBagTagItem } from "./CargoManifestBagTagItem/CargoManifestBagTagItem";

type formFilter = {
    State: number;
    IDTransportDestinationOrigin: number;
    IDTransportDestinationDestinity: number;
    regexStr: string;
    Type: number
}

type formAddTG = {
    IDTransportGuide: number;
    TransportGuideDate: any;
}

type formTGuide = {
    Year: number;
    Month: number;
}

export const CargoManifest = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_CargoManifest);
    const tg = useDataBean(_TransportGuide);
    const tgItem = useDataBean(_TransportGuideItem);

    const paginator = usePaginator();
    const paginatorTg = usePaginator();
    const paginatorItem = usePaginator();

    const { missingFields, validate } = useRequiredFields(bean, ["IDTransportDestinationOrigin", "IDOffice", "IDTransportDestinationDestinity",])
    const [listaResult, setListaResult] = useState<any[]>([]);
    const [listaItemsResult, setListaItemsResult] = useState<any[]>([]);
    const [tguide, setTGuide] = useState<Record<string, any>>({});

    const [formtg, setFormTG] = useState<Partial<formTGuide>>({
        Year: _single.getCurrenYear(),
    });
    const [filter, setFilter] = useState<Partial<formFilter>>({})

    const modal = useModal("", MODAL_LG);
    const modalAddTG = useModal("", MODAL_XL);
    const modalTG = useModal("", MODAL_XL);
    const modalC = useModal("Eliminar Manifieto", MODAL_SM);
    const modalItems = useModal("", MODAL_LG);
    const modalBagsItems = useModal("", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [paginator.page])

    const getLista = () => {
        instance.getCargoManifestCatalogvdos(filter.Type, filter.State, filter.IDTransportDestinationOrigin, filter.IDTransportDestinationDestinity, filter.regexStr, paginator.page, 15).then(
            (resp: any) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * (15));
                paginator.setRegiPerPage(15)
                setLista(resp.List);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de Manifiestos de Carga");
        });
    };

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            Since: _single.getCurrenDate(),
        });
        modal.open(`Agregar Manifiesto de Carga`);
    }


    const deleteItem = () => {
        instance.deleteCargoManifest(bean.IDCargoManifest).then(
            (resp) => {
                getLista();
                modalC.close();
            }
        ).catch(err => toast.error(err))
    };

    const editaItem = () => {

        if (validate() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        }

        instance.updateCargoManifest(bean).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDCargoManifest', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Oficina', property: 'OfficeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'ID Vuelo', property: 'IDFlight', visible: true },
        { title: 'Número de Vuelo', property: 'FlightName', visible: true },
        { title: 'Aeronave', property: 'AirCraft', visible: true },
        { title: 'Orígen', property: 'TransportDestinationOrigin', visible: true },
        { title: 'Destino', property: 'TransportDestinationDestinity', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },
        { title: 'Peso (KG)', property: 'WeightKg', visible: true },
        { title: 'Estado', property: 'CargoManifestStateName', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]


    const renderUserAdressed = (item: any) => {
        let render =
            ` 
        <div>            
            <strong>NIT: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeNit : 'NA'}</small><br />
            <strong>Contacto: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeName : 'NA'}</small><br />            
            <strong>Dirección: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddressesAddress : 'NA'}</small><br />            
            <strong>Correo: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeEmail : 'NA'}</small><br />            
            <strong>Telefono: </strong><small>${item.DataBeanProperties.IDAccountAddressee ? item.DataBeanProperties.AccountAddresseeTel : 'NA'}</small><br />            
        </div>
        `
        return render;
    }

    const renderUserSender = (item: any) => {
        let render =
            ` 
        <div>            
            <strong>NIT: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountCustomerNit : 'NA'}</small><br />
            <strong>Contacto: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountCustomerName : 'NA'}</small><br />            
            <strong>Dirección: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountAddress : 'NA'}</small><br />            
            <strong>Correo: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountEmail : 'NA'}</small><br />            
            <strong>Telefono: </strong><small>${item.DataBeanProperties.IDAccountCustomer ? item.DataBeanProperties.AccountTel : 'NA'}</small><br />            
        </div>
        `
        return render;
    }

    const getTGuideList = () => {
        instance.getTransportGuideListForCargoManifest(formtg.Year, formtg.Month, null, null, null, null, null, null, null, null, null, null, null, null, null, null, paginatorTg.page, 15).then(
            (resp) => {
                paginatorTg.setPages(resp.NumberOfPages);
                paginatorTg.setRecords(resp.NumberOfPages * (15));
                paginatorTg.setRegiPerPage(15)
                // setLista(resp.List)
                let x = resp.List;
                x.forEach((guide) => {
                    guide.DataBeanProperties.Rute = (guide.DataBeanProperties.TransportDestinationOrigin ?? "") + "-" + (guide.DataBeanProperties.TransportDestinationDestinity ?? "");
                    guide.DataBeanProperties.EntityAdressed = renderUserAdressed(guide);
                    guide.DataBeanProperties.EntitySender = renderUserSender(guide);


                });
                tg.setLista(x)
                modalAddTG.open("Agregar Guia de Transporte")
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Manifiesto") } },
            { titulo: 'Agregar Guia de Trasporte', icono: 'ri-add-box-line', visible: (bean.Type === 6 && _single.canCreate()), evento: () => { getTGuideList() } },
            { titulo: 'Agregar Pieza de Guia de Trasporte', icono: 'ri-add-box-line', visible: (bean.Type === 6 && _single.canCreate()), evento: () => { modalItems.open("Agregar Piezaas de Guia de Transporte"); tgItem.setLista([]); } },
            { titulo: 'Ver Guías de Transporte en Manifiesto de carga', icono: 'ri-list-check-2', visible: (bean.Type === 6 && _single.canCreate()), evento: () => { modalTG.open("Guias de Transporte en Manifiesto") } },
            { titulo: 'Ver Maletas en Manifiesto de carga', icono: 'ri-list-check-2', visible: (bean.Type === 7 && _single.canCreate()), evento: () => { modalBagsItems.open("Maletas en Manifiesto") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const addTransportGuidesBatch = async () => {

        if (!listaResult.length) {
            toast.error("No hay guías seleccionadas");
            return;
        }

        const exitos: number[] = [];
        const errores: any[] = [];

        const promises = listaResult.map(item => {

            return instance.addTransportGuide(
                bean.IDCargoManifest,
                item.DataBeanProperties.IDTransportGuide,
                item.DataBeanProperties.TransportGuideDate,
                _single.getAccountID()
            )
                .then(() => {
                    exitos.push(item.DataBeanProperties.IDTransportGuide);
                })
                .catch((error: any) => {
                    console.log(error)
                    errores.push({
                        id: item.DataBeanProperties.IDTransportGuide,
                        mensaje: error?.message || "Error desconocido"
                    });
                });

        });

        await Promise.all(promises);


        if (errores.length > 0) {
            toast.info(
                `Se agregaron ${exitos.length} guías correctamente.
                ${errores.length} presentaron error.`
            );
        } else {
            toast.success(`Se agregaron ${exitos.length} guías correctamente.`);
            getLista();
            setListaResult([]);
            modalAddTG.close();
            modalTG.open("Guias de Transporte en Manifiesto");
        }
    };

    const tghead = [
        { title: 'ID', property: 'IDTransportGuide', visible: true },
        { title: 'Fecha Emisión', property: 'TransportGuideDate', visible: true },
        { title: 'Código Guia', property: 'TransportGuideCode', visible: true },
        { title: 'Consecutivo GUIA', property: 'TransportGuideConsecutive', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Oficina', property: 'OfficeName', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Caja', property: 'CashDeskAccountName', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
        { title: 'Tipo Documento', property: 'TransportGuideDocTypeName', visible: true },
        { title: 'Utiliza Convenio', property: 'UseProject', visible: true, mask: MASK_BOOLEAN },
        { title: 'Convenio', property: 'ProjectName', visible: true },
        { title: 'Cliente', property: 'EntitySender', visible: true, Style: { minWidth: "250px" } },
        { title: 'Servicio de Entrega', property: 'TransportServiceName', visible: true },
        { title: 'Tipo Facturación', property: 'InvoiceFreightTypeName', visible: true },
        { title: 'Número de Piezas', property: 'PiecesNumber', visible: true },
        { title: 'Ruta de Carga', property: 'Rute', visible: true, Style: { minWidth: "150px" } },
        { title: 'Formas de Pago', property: 'PaymentMeansID', visible: true },
        { title: 'Métodos de Pago', property: 'PaymentMeansCode', visible: true },
        { title: 'Valor Guía', property: 'TotalAmount', visible: true },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Total Pagos', property: 'TotalPayment', visible: true },
        { title: 'Facturar a', property: 'InvoiceToTypeName', visible: true },
        { title: 'Conctacto Cliente', property: 'EntityAdressed', visible: true, Style: { minWidth: "250px" } },
        { title: 'Estado de Carga', property: 'GoodsStateName', visible: true },
        { title: 'Soporte de Carga', property: 'GoodsSupportName', visible: true },
        { title: 'Tipo de Carga', property: 'FreightTypeName', visible: true },
        { title: 'Valor Declarado', property: 'GoodsValue', visible: true, mask: MASK_MONEY },
        { title: 'Peso (KG)', property: 'WeightKg', visible: true },
        { title: 'Longitud', property: 'LongLength', visible: true },
        { title: 'Alto', property: 'HightLength', visible: true },
        { title: 'Ancho', property: 'WidthLength', visible: true },
        { title: 'Observaciones Carga', property: 'GoodsDescription', visible: true },
    ]

    const HeadItem = [
        { title: 'ID', property: 'IDTransportGuideItem', visible: true },
        { title: 'Estado de Carga', property: 'GoodsStateName', visible: true },
        { title: 'Soporte de Carga', property: 'GoodsSupportName', visible: true },
        { title: 'Tipo de Carga', property: 'GoodsTypeName', visible: true },
        { title: 'Peso (Kg)', property: 'WeightKg', visible: true },
        { title: 'P/Real (Kg)', property: 'WeightKgReal', visible: true },
        { title: 'Largo (cm)', property: 'LongLength', visible: true },
        { title: 'Ancho (cm)', property: 'WidthLength', visible: true },
        { title: 'Alto (cm)', property: 'HightLength', visible: true },
        { title: 'Descripción Pieza', property: 'Description', visible: true },
    ]

    const getItems = () => {
        tgItem.instance.getTransportGuideItemCatalog(tguide.IDTransportGuide, tguide.TransportGuideDate, paginatorItem.page, 15).then(
            (resp) => {
                paginatorItem.setPages(resp.NumberOfPages);
                paginatorItem.setRecords(resp.NumberOfPages * (15));
                paginatorItem.setRegiPerPage(15)
                tgItem.setLista(resp.List)
            }
        ).catch(err => { toast.error(err) });
    }

    const addTransportGuidesPieceBatch = async () => {

        if (!listaItemsResult.length) {
            toast.error("No hay guías seleccionadas");
            return;
        }

        const exitos: number[] = [];
        const errores: any[] = [];

        const promises = listaItemsResult.map(item => {

            return instance.addTransportGuideItem(
                bean.IDCargoManifest,
                item.DataBeanProperties.IDTransportGuideItem,
                item.DataBeanProperties.TransportGuideDate,
                _single.getAccountID()
            )
                .then(() => {
                    exitos.push(item.DataBeanProperties.IDTransportGuideItem);
                })
                .catch((error: any) => {
                    console.log(error)
                    errores.push({
                        id: item.DataBeanProperties.IDTransportGuideItem,
                        mensaje: error?.message || "Error desconocido"
                    });
                });

        });

        await Promise.all(promises);


        if (errores.length > 0) {
            toast.info(
                `Se agregaron ${exitos.length} Piezas correctamente.
                ${errores.length} presentaron error.`
            );
        } else {
            toast.success(`Se agregaron ${exitos.length} piezas correctamente.`);
            getLista();
            setListaItemsResult([]);
            modalItems.close();
            modalTG.open("Guias de Transporte en Manifiesto");
        }
    };


    return (
        <BasicPage titulo="Manifiestos de Carga">
            <div className="row">
                <div className="col-md-6">
                    <SelectCargoManifestType idSelector={filter.Type} onChange={(e) => { setFilter({ ...filter, Type: e }) }} />
                </div>
                <div className="col-md-6">
                    <SelectCargoManifest idSelector={filter.State} onChange={(e) => { setFilter({ ...filter, State: e }) }} label="Estado" />
                </div>
                <div className="col-md-6">
                    <TransportDestinationEditor idSelector={filter.IDTransportDestinationOrigin} onChange={(e) => { setFilter({ ...filter, IDTransportDestinationOrigin: e }) }} returnType="ID" />
                </div>
                <div className="col-md-6">
                    <TransportDestinationEditor label="Destino" idSelector={filter.IDTransportDestinationDestinity} onChange={(e) => { setFilter({ ...filter, IDTransportDestinationDestinity: e }) }} returnType="ID" />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={filter.regexStr} onChange={(e) => { setFilter({ ...filter, regexStr: e.target.value }) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-search-line" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} records={paginator} />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem() }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDOffice') ? 'has-error' : ''}`}>Oficina</label>
                                <EditorOfficeNew render={bean.OfficeName} idSelector={bean.IDOffice} onChange={(e) => { setBean({ ...bean, IDOffice: e }) }} label=" " />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label >ID Vuelo</label>
                                <input type="number" className="form-control" value={bean.IDFlight} onChange={(e) => {
                                    const valor = e.target.value ? Number(e.target.value) : null;
                                    setBean({ ...bean, IDFlight: valor })
                                }} />
                            </div>
                            <div className="col-md-6">
                                <SelectCargoManifestType idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, Type: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <EditorCurrentFlights label="Vuelo" idSelector={0} render={bean.FlightName} onChange={(e) => { setBean({ ...bean, FlightName: e.CallSign }); }} returnType="Object" />

                                {/* <label> Numero de Vuelo</label>
                                <input type="text" className="form-control" value={bean.FlightName} onChange={(e) => { setBean({ ...bean, FlightName: e.target.value }) }} /> */}
                            </div>
                            <div className="col-md-6">
                                <EditorAircraft idSelector={bean.AirCraft} onChange={(e) => { setBean({ ...bean, AirCraft: e }) }} label="Aeronave" />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDTransportDestinationOrigin') ? 'has-error' : ''}`}>Origen</label>
                                <TransportDestinationEditor render={bean.TransportDestinationOrigin} label=' ' idSelector={bean.IDTransportDestinationOrigin} onChange={(e) => { setBean({ ...bean, IDTransportDestinationOrigin: e }) }} returnType="ID" />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDTransportDestinationDestinity') ? 'has-error' : ''}`}>Destino</label>
                                <TransportDestinationEditor render={bean.TransportDestinationDestinity} label=' ' idSelector={bean.IDTransportDestinationDestinity} onChange={(e) => { setBean({ ...bean, IDTransportDestinationDestinity: e }) }} returnType="ID" />
                            </div>
                            <div className="col-md-6">
                                <label>Peso (KG)</label>
                                <input type="number" className="form-control" value={bean.WeightKg} onChange={(e) => {
                                    const valor = e.target.value ? parseFloat(e.target.value) : null
                                    setBean({ ...bean, WeightKg: valor })
                                }} />
                            </div>
                            <div className="col-md-12">
                                <label >Observaciones</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>

                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>

                    <Modal modal={modalAddTG.modal} updateModal={modalAddTG.setModal} eventModal={() => { addTransportGuidesBatch() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <BasicMultiSelectTable body={tg.lista} bodyResult={listaResult} head={tghead} keyId="IDTransportGuide" updateValues={({ bodyResult }) => { setListaResult(bodyResult) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalItems.modal} updateModal={modalItems.setModal} eventModal={() => { addTransportGuidesPieceBatch() }} >
                        <div className="row">
                            <div className="col-md-8">
                                <EditorTransportGuideForCargoManifest idSelector={tguide.IDTransportGuide} onChange={(e) => { setTGuide(e) }} label="Guia de transpoerte" returnType="Object" />
                            </div>
                            <div className="col-md-4">
                                <BasicButton useMargin eventClick={() => { getItems() }} icon="ri-search-line" children={`Buscar`} />
                            </div>
                            <div className="col-md-12">
                                <BasicMultiSelectTable body={tgItem.lista} bodyResult={listaItemsResult} head={HeadItem} keyId="IDTransportGuideItem" updateValues={({ bodyResult }) => { setListaItemsResult(bodyResult) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalBagsItems.modal} updateModal={modalBagsItems.setModal} >
                        <CargoManifestBagTagItem CargoManifest={bean} />
                    </Modal>

                    <Modal modal={modalTG.modal} updateModal={modalTG.setModal}  >
                        <CargoManifestTransportGuides CargoManifest={bean} />
                    </Modal>

                </div>
            </div >
        </BasicPage >
    )
}